import React, { useEffect, useState, useRef } from "react";

const Terms: React.FC = () => {
    return (
        <div
            className="container"
            style={{
                fontFamily: "Noto Sans",
            }}
        >
            <div>
                <h1
                    style={{
                        textAlign: "center",
                        width: "100%",
                    }}
                >
                    Terms and Conditions of Use
                </h1>
                <p>
                    Welcome to ReThink Travel (rethinktravel.org), a platform
                    designed to help individuals and organizations offset their
                    travel-related carbon emissions through curated, Green
                    Projects. These Terms and Conditions of Use ("Terms")
                    constitute a legally binding agreement between you ("User,"
                    "you," “traveler”, or "your") and ReThink Travel ("ReThink,"
                    “Re”, “Portal”, “Platform”, “Company”, "we," “GetRe”, "us,"
                    or "our").
                </p>
                <p>
                    By accessing or using the ReThink Travel website (the
                    “Site”), platform, services, features, content, anything
                    that is related to the platform, or mobile applications
                    (collectively, the "Services"), you acknowledge that you
                    have read, understood, and agree to be bound by these Terms.
                    If you do not agree with any part of these Terms, please do
                    not access or use the Services.
                </p>
                <p>
                    By visiting our site and/or using the platform, you engage
                    in our “Service” and agree to be bound by the following
                    terms and conditions (“Terms of Service”, “Terms”),
                    including those additional terms and conditions and policies
                    referenced herein and/or available by hyperlink. These Terms
                    of Service apply to all users of the platform, including
                    without limitation users who are browsers, contributors of
                    content, and/or registered users.
                </p>
                <p>
                    Please read these Terms of Service carefully before
                    accessing or using our platform, products, or services. By
                    accessing or using any part of the platform or service, you
                    agree to be bound by these Terms of Service. If you do not
                    agree to all the terms and conditions of this agreement,
                    then you may not access the platform or use any products or
                    services. If these Terms of Service are considered an offer,
                    acceptance is expressly limited to these Terms of Service.
                </p>
                <p>
                    Any new features or tools which are added to the current
                    platform shall also be subject to the Terms of Service. You
                    can review the most current version of the Terms of Service
                    at any time on this page. We reserve the right to update,
                    change, or replace any part of these Terms of Service by
                    posting updates and/or changes to our platform. It is your
                    responsibility to check this page periodically for changes.
                    Your continued use of or access to the platform following
                    the posting of any changes constitutes acceptance of those
                    changes.
                </p>
                <h1>Eligibility/Use of Service</h1>
                <p>
                    By signing up and using ReThink Travel, you warrant that you
                    are legally capable of entering into binding contracts, that
                    all registration information you submit is truthful and
                    accurate, and that your use of the Service does not violate
                    any law or regulation of any country across the world. Users
                    under the age of 18 must have the consent of a parent or
                    legal guardian to use the Service.
                </p>
                <p>
                    If you are using the Services on behalf of an organization
                    or entity, you represent and warrant that you are authorized
                    to bind that organization to these Terms.
                </p>
                <p>
                    ReThink Travel is provided on an "as-is" and "as-available"
                    basis. We make no warranties, express or implied, including
                    but not limited to implied warranties of merchantability,
                    fitness for a particular purpose, and non-infringement of
                    intellectual property or other violation of rights.
                </p>
                <p>
                    Further, we do not warrant or make any representations
                    concerning the accuracy, likely results, or reliability of
                    the use of the Service or Platform or the Data.
                </p>
                <p>
                    By accessing or using the Portal or ReThink, you agree to be
                    bound by these Terms and our Privacy Policy. If you do not
                    agree to these Terms, do not use the Portal.
                </p>
                <h1>Third-Party Links & Services</h1>
                <p>
                    The Portal may contain links to third-party websites or
                    services that are not owned or controlled by ReThink.
                    ReThink has no control over and assumes no responsibility
                    for the content, privacy policies, or practices of any
                    third-party websites, apps, products, or services.
                </p>
                <h1>Personal Information</h1>
                <p>
                    You may be asked to enter your personal information on the
                    platform or by our support executives. This information is
                    collected as per the requirement mandated for the use of the
                    platform and will be governed by our Privacy Policy.
                </p>
                <p>
                    ReThink retains user data for as long as necessary to
                    provide the Services or as required by law. Users may
                    request deletion of their data by contacting us at
                    rethink@getre.org, and ReThink will process such requests in
                    accordance with applicable laws.
                </p>
                <p>
                    Deletion of data requests will be processed as soft deletion
                    requests by making the personal identification details as
                    ‘Anonymous.’
                </p>
                <p>
                    Your personal information like phone number, email address,
                    name, geo-location etc. (but not limited to these) will be
                    used to communicate with you. By submitting your response,
                    you agree for us to reach out to you on WhatsApp, Emails,
                    SMS, and more.
                </p>
                <p>
                    Users may request to unsubscribe from any/all communications
                    by contacting us at rethink@getre.org.
                </p>
                <h1>Services Overview</h1>
                <p>
                    ReThink Travel allows users to:
                    <ul>
                        <li>
                            Calculate the carbon emissions associated with their
                            travel.
                            <ul>
                                <li>
                                    Carbon emissions are calculated using
                                    best-available methods and publicly sourced
                                    data, but results may vary depending on
                                    factors such as (including but not limited
                                    to) travel behavior, location, Green
                                    Projects, weather, mode of transport, local
                                    infrastructure, and data availability.
                                    ReThink does not guarantee the absolute
                                    accuracy of emission estimates.
                                </li>
                            </ul>
                        </li>
                        <li>
                            Offset those emissions by contributing funds to
                            environmental or sustainability projects ("Green
                            Projects" or “Projects”).
                            <ul>
                                <li>
                                    The Green Projects could be run or developed
                                    by a third-party or ReThink, depending on
                                    the selection of the project - the funds
                                    will be transferred to the respective
                                    project.
                                </li>
                                <li>
                                    For projects executed by third parties,
                                    ReThink is not responsible for
                                    implementation delays or failures. In such
                                    cases, the executing party shall be
                                    responsible for delivering the intended
                                    outcomes. ReThink disclaims liability for
                                    third-party performance and will not be held
                                    accountable in case of non-performance.
                                </li>
                                <li>
                                    ReThink Travel is committed to offset the
                                    carbon footprint (in kgs) for which funds
                                    are received from users.
                                </li>
                                <li>
                                    Certain initiatives may involve the purchase
                                    or allocation of carbon credits. In
                                    instances where ReThink Travel selects and
                                    administers such carbon credit projects, all
                                    associated rights, titles, and interests in
                                    said credits shall remain exclusively with
                                    ReThink Travel. Users and travelers shall
                                    not acquire any ownership, claim, or control
                                    over the credits or their associated
                                    benefits.
                                </li>
                            </ul>
                        </li>
                        <li>
                            Track their environmental impact and receive updates
                            regarding project implementation and progress.
                            <ul>
                                <li>
                                    The timeline for the project and
                                    communication may vary due to natural,
                                    logistical, or regulatory conditions, and we
                                    may not always have control over the
                                    timeline.
                                </li>
                            </ul>
                        </li>
                    </ul>
                </p>
                <p>
                    The offset contributions may include a service fee, which
                    covers administrative, platform, searching and evaluation of
                    the Green Project, technology, and operational costs. This
                    fee may vary but will not exceed 50% of the base offset
                    amount. The standard fee is currently 20% unless otherwise
                    indicated.
                </p>
                <p>
                    The term 'travel' as used herein shall be interpreted
                    broadly to include, without limitation, accommodations,
                    transportation by air, rail, sea, road, or any other means,
                    local commuting solutions, transit between locations, any
                    activities undertaken during the course of travel, and all
                    other services or experiences reasonably falling within the
                    travel domain.
                </p>
                <p>
                    We reserve the sole right, at our discretion and without
                    prior notice, to introduce, modify, suspend, or discontinue
                    any features, services, or offerings made available through
                    the platform.
                </p>
                <h1>Contributions and Payments</h1>
                <p>
                    By making a contribution to offset carbon emissions, you
                    authorize ReThink to process the payment using third-party
                    payment processors. You acknowledge that payments are final
                    and non-refundable unless explicitly stated otherwise.
                </p>
                <p>
                    Contributions are used to support selected Green Projects,
                    which may be executed by third-party partners or ReThink.
                    ReThink retains sole discretion over the selection, funds,
                    timelines, and execution of these projects.
                </p>
                <p>
                    You acknowledge that the carbon offsetting does not
                    constitute a guarantee of personal carbon neutrality but is
                    a contribution towards emission-reduction initiatives.
                </p>
                <h1>Green Project Execution and Fund Allocation</h1>
                <p>
                    While we aim to ensure maximum impact and transparency,
                    timelines for Green Projects may vary due to natural,
                    logistical, or regulatory conditions.
                </p>
                <p>
                    ReThink reserves the right to reallocate funds to similar,
                    and impact-aligned projects in the event of unforeseen
                    challenges, ensuring that the original environmental intent
                    of the contribution is preserved.
                </p>
                <p>
                    ReThink disclaims liability for delays or shortfalls caused
                    by third-party project implementers, but will endeavor to
                    communicate project status to users when possible.
                </p>
                <h1>User Obligations and Conduct</h1>
                <p>
                    You agree to use the Services in compliance with all
                    applicable local, state, national, and international laws.
                </p>
                <p>
                    You agree not to:
                    <ul>
                        <li>
                            Interfere with or disrupt the Services or servers.
                        </li>
                        <li>Impersonate any person or entity.</li>
                        <li>Provide false or misleading information.</li>
                        <li>
                            Upload or distribute any harmful code or material.
                        </li>
                    </ul>
                </p>
                <p>
                    All Users must comply with the following rules regarding
                    acceptable use of the Service:
                    <ul>
                        <li>
                            You may not access, tamper with, or use non-public
                            areas of the Service and Websites.
                        </li>
                        <li>
                            You may not probe, scan, or test the vulnerability
                            of any system or network or breach or circumvent any
                            security or authentication measures.
                        </li>
                        <li>
                            You may not access or search the Service and
                            Websites by any means other than intended by us.
                        </li>
                        <li>
                            You may not misuse the Service to carry out,
                            promote, or support any unlawful or fraudulent
                            activities.
                        </li>
                        <li>
                            You may not use the platform or its data for
                            personal or commercial gains.
                        </li>
                        <li>
                            You may not use or copy the code, idea, design, or
                            anything about ReThink Travel to make financial
                            gains.
                        </li>
                        <li>
                            You may not replicate, reverse-engineer, or
                            commercially exploit any part of ReThink Travel’s
                            intellectual property without explicit consent.
                        </li>
                        <li>
                            The accuracy of CO2e or similar data provided by the
                            platform is based on the information submitted by
                            the user, and any discrepancies in user submissions
                            will affect the accuracy of the results. We do not
                            take any responsibility for the accuracy of data or
                            calculations of any kind of data. The calculations
                            are estimates based on user input, not certified
                            scientific measurements.
                        </li>
                        <li>
                            Users are responsible for maintaining the
                            confidentiality of their account information,
                            including their username and password, and for all
                            activities that occur under their account. Users are
                            responsible for providing accurate information for
                            ReThink to send them further communications.
                        </li>
                        <li>
                            ReThink may use third-party
                            applications/products/services like WhatsApp, SMS
                            services, hosting providers, and other service
                            providers to provide Services on ReThink. All Terms
                            and Conditions mentioned in this agreement will be
                            applicable for third-party providers’ services. Use
                            of third-party services is subject to their
                            respective terms and policies.
                        </li>
                        <li>
                            Users will be given an option to offset their carbon
                            footprint or to donate to ReThink to run Green
                            Projects and for the maintenance of platform or
                            services. ReThink will not be responsible for any
                            misrepresentation, remedy, communication gap or
                            disputes arising from the usage of peripheral
                            services or products.
                        </li>
                        <li>
                            A monthly subscription fee for the usage of ReThink
                            may be applicable for a certain type of users.
                        </li>
                        <li>
                            No refund will be offered for any/all intents and
                            purposes. Any amount paid to ReThink that
                            constitutes payment for the provision of unused
                            Products or Services, will not be refunded.
                        </li>
                        <li>
                            Users can request to export their data of usage of
                            the platform by contacting us at rethink@getre.org.
                        </li>
                    </ul>
                </p>
                <p>
                    You are responsible for maintaining the confidentiality of
                    your usage, credentials, any other activity you perform and
                    are liable for all activities you have performed.
                </p>
                <h1>Errors, Inaccuracies, and Omissions</h1>
                <p>
                    Occasionally there may be information on our platform or in
                    the Service that contains typographical errors,
                    inaccuracies, or omissions that may relate to CO2e
                    calculations, initiatives, micro-actions, product
                    descriptions, funds, offset amounts, Green Projects,
                    pricing, processes, promotions, offers, product shipping
                    charges, transit times, and availability. We reserve the
                    right to correct any errors, inaccuracies, or omissions, and
                    to change or update information or cancel Services if any
                    information in the Service or on any related platform is
                    inaccurate at any time without prior notice (including after
                    you have submitted your request and made payments for the
                    same).
                </p>
                <p>
                    We undertake no obligation to update, amend, or clarify
                    information in the Service or on any related platform,
                    including without limitation, pricing information, except as
                    required by law. No specified update or refresh date applied
                    in the Service or on any related platform should be taken to
                    indicate that all information in the Service or on any
                    related platform has been modified or updated.
                </p>
                <p>
                    We reserve the right to correct any such errors or to cancel
                    or refuse any service affected by such inaccuracies, at our
                    sole discretion and without prior notice.
                </p>
                <h1>Intellectual Property</h1>
                <p>
                    All (including but not limited to) content, trademarks,
                    service marks, trade names, logos, software, and
                    intellectual property on the Site and Services are owned by
                    or licensed to ReThink, and are protected under intellectual
                    property laws.
                </p>
                <p>
                    You may not copy, reproduce, distribute, modify, or create
                    derivative works of any content on the Services without
                    prior written consent from ReThink.
                </p>
                <h1>Disclaimer of Warranties</h1>
                <p>
                    The Services are provided "as is" and "as available,"
                    without warranties of any kind, either express or implied,
                    including but not limited to implied warranties of
                    merchantability, fitness for a particular purpose, and
                    non-infringement.
                </p>
                <p>
                    We do not guarantee, represent, or warrant that your use of
                    our platform/product/Services will be uninterrupted, timely,
                    secure, free from harmful components, or error-free. We do
                    not warrant that the results that may be obtained from the
                    use of the product will be accurate or reliable. You
                    expressly agree that your use of, or inability to use, the
                    platform, product or service is at your sole risk.
                </p>
                <p>
                    The product or service available to you (except as expressly
                    stated by us) is provided ‘as is’ and ‘as available’ for
                    your use, without any representation, warranties, or
                    conditions of any kind, either express or implied, including
                    all implied warranties or conditions of merchantability,
                    merchantable quality, fitness for a particular purpose,
                    durability, title, and non-infringement.
                </p>
                <h1>Limitation of Liability</h1>
                <p>
                    To the maximum extent permitted by law, ReThink shall not be
                    liable for any indirect, incidental, special, consequential,
                    or punitive damages, or loss of profits, data, or use.
                </p>
                <p>
                    To the fullest extent permitted by law, ReThink and its
                    affiliates shall not be liable for any direct or indirect
                    damages, including loss of data, profits, or use, arising
                    from the use or inability to use our Services.
                </p>
                <p>
                    Our total aggregate liability for any claims under these
                    Terms shall not exceed INR 100, regardless of the form of
                    action, whether in contract, tort, or otherwise.
                </p>
                <p>
                    In no case shall GetRe or Re or ReThink or ReThink Travel,
                    our directors, officers, employees, affiliates, agents,
                    contractors, interns, suppliers, service providers, partners
                    or licensors be liable for any injury, loss, claim, or any
                    direct, indirect, incidental, punitive, special, or
                    consequential damages of any kind, including, without
                    limitation, lost profits, lost revenue, lost savings, loss
                    of data, loss of money, replacement costs, or any similar
                    damages, whether based in contract, tort (including
                    negligence), strict liability, or otherwise, arising from
                    your use of any of the service or any products procured
                    using the service or any service or products procured
                    through our third party collaborations, or for any other
                    claim related in any way to your use of the service or any
                    product, including, but not limited to, any errors or
                    omissions in any content, or any loss or damage of any kind
                    incurred as a result of the use of the service or any
                    content (or product) posted, transmitted, or otherwise made
                    available via the service, even if advised of their
                    possibility.
                </p>
                <h1>Indemnification</h1>
                <p>
                    You agree to indemnify, defend, and hold harmless ReThink,
                    its affiliates, directors, officers, employees, agents, and
                    partners from and against any claims, liabilities, damages,
                    losses, and expenses (including reasonable attorney's fees)
                    arising out of or related to:
                    <ul>
                        <li>
                            your use of the platform, products, or services,
                        </li>
                        <li>
                            your violation of these Terms, applicable laws, or
                            third-party rights.
                        </li>
                        <li>
                            violation of anything else not mentioned herein.
                        </li>
                    </ul>
                </p>
                <p>
                    You agree to indemnify, defend, and hold harmless GetRe or
                    Re or ReThink or ReThink Travel and our parent,
                    subsidiaries, affiliates, founders, co-founders, partners,
                    officers, directors, agents, contractors, licensors, service
                    providers, subcontractors, suppliers, interns, and
                    employees, harmless from any claim or demand, including
                    reasonable attorneys’ fees, made by any third-party due to
                    or arising of your use of this platform or portal or
                    products or services or the documents they incorporate by
                    reference, or your violation of any law or the rights of a
                    third party.
                </p>
                <p>
                    ReThink Travel shall not be liable for any indirect,
                    incidental, special, consequential, or punitive damages, or
                    any loss of profits or revenues, whether incurred directly
                    or indirectly, or any loss of data, use, goodwill, or other
                    intangible losses, resulting from the user’s reliance on the
                    information provided by ReThink.
                </p>
                <h1>Severability</h1>
                <p>
                    In the event that any provision of these Terms of Service is
                    determined to be unlawful, void, or unenforceable, such
                    provision shall nonetheless be enforceable to the fullest
                    extent, and the unenforceable portion shall not be deemed to
                    be severed from these Terms of Service; such determination
                    shall not affect the validity and enforceability of any
                    other remaining provisions.
                </p>
                <h1>Copyright, Notice, and License</h1>
                <p>
                    The (including but not limited to) information, data,
                    content, graphics, ideas, text, sounds, images, buttons,
                    trademarks, service marks, trade names, and logos
                    ("Materials") contained in this platform are protected by
                    copyright, trademark, database right, and other intellectual
                    property laws under national laws and international
                    treaties.
                </p>
                <p>
                    GetRe or Re or ReThink or ReThink Travel or its licensors
                    (as the case may be) retain all right, title, interest, and
                    intellectual property rights in and to the Materials. You
                    may not modify, copy, distribute, transmit, display,
                    perform, rebroadcast, reproduce, publish, license, create
                    derivative works from, transfer, or sell any information,
                    ideas, initiatives, micro-actions, materials, software,
                    products, or services obtained from this platform. Anyone
                    breaching any of these provisions will be prosecuted.
                </p>
                <p>
                    All content on the Platform, including text, graphics,
                    micro-actions, images, logos, and software, is the property
                    of ReThink Travel or its licensors and is protected by
                    applicable intellectual property laws.
                </p>
                <p>
                    Users may not copy, reproduce, distribute, or create
                    derivative works without express written permission.
                </p>
                <p>
                    ReThink may use User’s Company Name and Logo for displaying
                    on the Portal site. ReThink may use the User’s company name
                    and logo for the marketing and promotional purposes.
                </p>
                <p>
                    ReThink reserves the right to display the User’s name on the
                    Platform and in marketing material. This does not grant the
                    User any rights to ReThink’s branding unless expressly
                    agreed.
                </p>
                <p>
                    Using the Services does not authorise the User ownership of
                    any intellectual property rights in the Services or the
                    content the User accesses. The User may not use content from
                    the Services unless permission has been obtained from the
                    owner.
                </p>
                <h1>Nondisclosure and Noncompetition</h1>
                <p>
                    The User agrees to respect the confidentiality of the
                    data/information generated by the Portal and not to disclose
                    them to anyone. The User agrees not to make use of research
                    done in the course of work for the Portal while employed by
                    any of our competitors. The User agrees not to set up a
                    business as a direct competitor of the Portal for a period
                    of 3 years internationally from the last time of their usage
                    of the Portal. The User agrees to pay liquidated damages as
                    asked by ReThink Travel if any violation of this paragraph
                    is proved or admitted.
                </p>
                <h1>Cookie Policy</h1>
                <p>
                    We use cookies. Cookies are small files that a site or its
                    service provider transfers to your computer’s hard drive
                    through your Web browser that enables the site’s or service
                    provider’s systems to recognize your browser and capture and
                    remember certain information. Your acceptance of these terms
                    and conditions and the usage of the platform, products
                    and/or services of ReThink is equivalent to providing the
                    consent to Rethink or platform to store cookies and use
                    them.
                </p>
                <h1>Entire Agreement</h1>
                <p>
                    These Terms and Conditions constitute the entire agreement
                    between the user and ReThink with respect to the use of the
                    Portal and Services, and supersede all prior or
                    contemporaneous understandings, agreements, representations,
                    and warranties, both written and oral, with respect to the
                    Portal and Services. These Terms and Conditions are also
                    applicable for all the peripheral products/subsidiary
                    companies/tools/partner portals like WhatsApp, SMS services,
                    hosting providers, other service providers that ReThink will
                    be using to share the information or provide the products
                    and services.
                </p>
                <h1>Force Majeure</h1>
                <p>
                    Neither party shall be liable to the other party for any
                    failure to perform any obligation under any Agreement which
                    is due to an event beyond the control of such party
                    including but not limited to any Act of God, terrorism, war,
                    Political insurgence, insurrection, riot, civil unrest, act
                    of civil or military authority, uprising, earthquake, flood
                    or any other natural or man-made event outside of either
                    parties control, which causes the termination of an
                    agreement entered into, nor which could have been reasonably
                    foreseen. Any Party affected by such event shall forthwith
                    inform the other Party of the same and shall use all
                    reasonable endeavours to comply with the terms and
                    conditions of any Agreement contained herein.
                </p>
                <h1>Termination</h1>
                <p>
                    ReThink may suspend or terminate your access to the Platform
                    or Services at any time, with or without notice, for any
                    reason including violation of these Terms. Upon termination,
                    all rights granted to you will cease immediately. Sections
                    related to intellectual property, indemnity, disclaimers,
                    and limitations of liability shall survive such termination.
                </p>
                <p>
                    The obligations and liabilities of the parties incurred
                    prior to the termination date shall survive the termination
                    of this agreement for all purposes. These Terms of Service
                    are effective unless and until terminated by either you or
                    us. You may terminate these Terms of Service at any time by
                    notifying us that you no longer wish to use our Services, or
                    when you cease using our services.
                </p>
                <p>
                    If in our sole judgement you fail, or we suspect that you
                    have failed, to comply with any term or provision of these
                    Terms of Service, we also may terminate this agreement at
                    any time without notice and you will remain liable for all
                    amounts due up to and including the date of termination;
                    and/or accordingly may deny you access to our Services (or
                    any part thereof).
                </p>
                <p>
                    ReThink may terminate or suspend your access to the Platform
                    or Services at any time, without prior notice or liability,
                    for any reason whatsoever, including without limitation if
                    you breach the Terms. Upon termination, your right to use
                    the Platform or Services will immediately cease.
                </p>
                <p>
                    ReThink reserves the right to modify, suspend, or
                    discontinue the Services (or any part thereof) at any time,
                    with or without notice to the user. Users agree that ReThink
                    shall not be liable to them or to any third party for any
                    modification, suspension, or discontinuation of the Platform
                    or Products or Services.
                </p>
                <h1>Governing Law and Dispute Resolution</h1>
                <p>
                    These Terms shall be governed by and construed in accordance
                    with the laws of India, without regard to its conflict of
                    law principles.
                </p>
                <p>
                    Any disputes arising out of or relating to these Terms or
                    the Services shall be subject to the exclusive jurisdiction
                    of the courts in Mumbai, India.
                </p>
                <h1>Changes to the Terms</h1>
                <p>
                    ReThink reserves the right to modify or update these Terms
                    at any time. Any changes will be effective upon posting on
                    the Site. Your continued use of the Services constitutes
                    acceptance of the revised Terms.
                </p>
                <h1>Contact Information</h1>
                <p>
                    For any queries regarding these Terms, please contact us at:
                    rethink@getre.org.
                </p>
            </div>
        </div>
    );
};

export default Terms;
